import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CreatorFullContents from './creator-full-contents';
import SideMenu from './SideMenu';

export default function ReportCreatorFull() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isLaptop = useMediaQuery(theme.breakpoints.down('lg'));
  const navigate = useNavigate();
  const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);
  const [leftPanelWidth, setLeftPanelWidth] = useState(1.5);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    // setLeftPanelWidth(0.58);
    setLeftPanelWidth(1);
  }, [isLeftPanelCollapsed]);

  useEffect(() => {
    if (isTablet) {
      navigate('/naver/report-creator');
    }
  }, [isTablet]);

  const customStyle = {
    width: '100%',
    overflow: 'hidden',
  };

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <>
      <Box sx={customStyle}>
        {/* Sidebar - Fixed position */}
        <SideMenu isOpen={mobileMenuOpen} onToggle={handleMobileMenuToggle} />

        {/* Main Content - Positioned to the right of sidebar */}
        <Box
          sx={{
            marginLeft: isTablet ? '0px' : '82px',
            overflow: 'auto',
            backgroundColor: 'white',
          }}
        >
          <CreatorFullContents />
        </Box>
      </Box>
    </>
  );
}
